import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledWalletWidgetContainer = styled.div`
  background: ${baseVariables.color['white'] || '#fff'};
  border-radius: 0;
  box-shadow: ${toRem(0)} ${toRem(2)} ${toRem(10)} ${toRem(0)} rgba(0, 0, 0, 0.07);
  box-sizing: border-box;
  overflow: hidden;
  margin-bottom: ${toRem(24)};

  @media ${baseVariables.mediaQuery.xl} {
    border-radius: ${toRem(14)};
  }

  .aem-container {
    padding: 0 !important;
  }

  .wallet-widget-container__header-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${toRem(20)} ${toRem(24)};
    min-height: ${toRem(72)};
    gap: ${toRem(16)};
    box-shadow: ${toRem(0)} ${toRem(2)} ${toRem(10)} ${toRem(0)} rgba(0, 0, 0, 0.07);

    @media ${baseVariables.mediaQuery.md} {
      padding: ${toRem(24)};
    }
  }

  .wallet-widget-container__header-section {
    display: flex;
    align-items: center;
    gap: ${toRem(16)};
    flex: 1;
    min-width: 0;
  }

  .wallet-widget-container__header-icon-wrapper {
    display: inline-flex;
    flex-shrink: 0;
    line-height: 1;
  }

  .wallet-widget-container__header-icon {
    font-size: ${toRem(24)};
    line-height: 1;
    font-style: normal;

    &::before {
      display: block;
      height: ${toRem(24)};
      width: ${toRem(24)};
    }

    @media ${baseVariables.mediaQuery.md} {
      font-size: ${toRem(32)};

      &::before {
        height: ${toRem(32)};
        width: ${toRem(32)};
      }
    }
  }

  .wallet-widget-container__header-label {
    flex: 1;
    min-width: 0;
    font-size: ${toRem(22)};
    font-weight: ${baseVariables.font.fontWeightMedium};
  }

  .wallet-widget-container__badge {
    display: inline-flex;
    align-items: center;
    background-color: ${baseVariables.color['neutral20']};
    border-radius: ${toRem(4)};
    height: ${toRem(22)};
    padding: 0 ${toRem(8)};
    gap: ${toRem(4)};
    flex-shrink: 0;
    color: ${baseVariables.color['base10']};
    white-space: nowrap;
    &.wallet-widget-container__badge--loading {
      background-color: transparent;
    }
  }

  .wallet-widget-container__badge-icon {
    color: ${baseVariables.color['base10']};
    font-size: ${toRem(16)};
    font-style: normal;
    line-height: 1;
    flex-shrink: 0;

    &::before {
      display: block;
      height: ${toRem(16)};
      width: ${toRem(16)};
    }
  }

  .wallet-widget-container__badge-text {
    color: ${baseVariables.color['base10']};
  }

  .wallet-widget-container__badge-skeleton {
    width: ${toRem(120)};
    height: ${toRem(14)};
  }

  .wallet-widget-container__body {
    padding: ${toRem(16)};
    display: flex;
    flex-direction: column;
    gap: ${toRem(32)};
    box-sizing: border-box;

    @media ${baseVariables.mediaQuery.xl} {
      padding: ${toRem(24)};
    }
  }

  .wallet-widget-container__content-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: ${toRem(260)};
    border-radius: ${toRem(8)};
    color: ${baseVariables.color['neutral30']};
    border-radius: var(--t-cards-border-radius, 8px);
    border: 1px dashed ${baseVariables.color['neutral30']};
  }

  &.wallet-widget-container--skeleton {
    .wallet-widget-container__skeleton-icon {
      width: ${toRem(24)};
      height: ${toRem(24)};
      flex-shrink: 0;

      @media ${baseVariables.mediaQuery.md} {
        width: ${toRem(32)};
        height: ${toRem(32)};
      }
    }

    .wallet-widget-container__skeleton-title {
      width: ${toRem(160)};
      height: ${toRem(22)};
    }

    .wallet-widget-container__skeleton-badge {
      width: ${toRem(120)};
      height: ${toRem(22)};
    }

    .wallet-widget-container__skeleton-body {
      height: ${toRem(200)};
    }
  }
`;
